import { render, staticRenderFns } from "./WriteOffItemModal.vue?vue&type=template&id=2176b3dc&scoped=true&"
import script from "./WriteOffItemModal.vue?vue&type=script&lang=js&"
export * from "./WriteOffItemModal.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffItemModal.vue?vue&type=style&index=0&id=2176b3dc&lang=scss&scoped=true&"
import style1 from "./WriteOffItemModal.vue?vue&type=style&index=1&id=2176b3dc&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2176b3dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2176b3dc')) {
      api.createRecord('2176b3dc', component.options)
    } else {
      api.reload('2176b3dc', component.options)
    }
    module.hot.accept("./WriteOffItemModal.vue?vue&type=template&id=2176b3dc&scoped=true&", function () {
      api.rerender('2176b3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform-items/modals/WriteOffItemModal.vue"
export default component.exports